import Service from "../../AuthService";

const BillingPayoff = {
    getBillingPayoffs(params) {
        return Service.get("/billing-payoff", {
            params: params
        })
    },
    getBillingPayoffById(id) {
        return Service.get("/billing-payoff/" + id)
    },
    getBillingPayoffCounts() {
        return Service.get("/billing-payoff/count")
    },
    createBillingPayoff(data) {
        return Service.post("/billing-payoff", data)
    },
    updateBillingPayoff(id, data) {
        return Service.put("/billing-payoff/" + id, data)
    },
    deleteBillingPayoff(id) {
        return Service.delete("/billing-payoff/" + id)
    },
    getCustomerByBilling(){
        return Service.get("/customer-by-billing")
    },
}

export default BillingPayoff
